export * from './w-mat-timepicker/w-mat-timepicker.component';
export * from './w-time-dialog/w-time-dialog.component';
export * from './w-clock/w-clock.component';
export * from './w-time/w-time.component';




// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/common/time-control/index.ts